import styled from '@emotion/styled';

export const SearchWrapper = styled.div`
  width: 200px;
`;

export const PayoutStatusHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
